import { __decorate } from "tslib";
import { injectable } from 'inversify';
let EditCustomFieldServiceImpl = class EditCustomFieldServiceImpl {
    setHandler(handler) {
        this._handler = handler;
    }
    edit(context) {
        this._handler(context.fields[0]);
    }
};
EditCustomFieldServiceImpl = __decorate([
    injectable()
], EditCustomFieldServiceImpl);
export { EditCustomFieldServiceImpl };
